import Vue from "vue";
import {
  mdiArrowRight,
  mdiArrowLeft,
  mdiClose,
  mdiPlusCircle,
  mdiCheckCircle,
  mdiEye,
  mdiEyeOff,
  mdiCloseCircle,
  mdiMagnify,
  mdiCloudOffOutline,
  mdiCloudOutline,
  mdiHelpCircleOutline,
  mdiCloseCircleOutline,
  mdiCheckCircleOutline,
  mdiSmokingOff,
  mdiSmoking,
  mdiPencilOutline,
  mdiTrashCanOutline,
  mdiPhone,
  mdiAccountCheckOutline,
  mdiAccountClockOutline,
  mdiAccountSearchOutline,
  mdiHelpCircle,
  mdiCalendar,
  mdiAccountCogOutline,
  mdiDownload,
  mdiCog,
  mdiContentCopy,
  mdiSafeSquare,
  mdiSafeSquareOutline,
  mdiEmail,
  mdiDoNotDisturb,
} from "@mdi/js";
import whitelabel from "../../whitelabel-config";

Vue.mixin({
  data: () => ({
    icons: {
      mdiArrowRight: mdiArrowRight,
      mdiArrowLeft: mdiArrowLeft,
      mdiClose: mdiClose,
      mdiPlusCircle: mdiPlusCircle,
      mdiCheckCircle: mdiCheckCircle,
      mdiEye: mdiEye,
      mdiEyeOff: mdiEyeOff,
      mdiCloseCircle: mdiCloseCircle,
      mdiMagnify: mdiMagnify,
      mdiCloudOffOutline: mdiCloudOffOutline,
      mdiCloudOutline: mdiCloudOutline,
      mdiHelpCircleOutline: mdiHelpCircleOutline,
      mdiCloseCircleOutline: mdiCloseCircleOutline,
      mdiCheckCircleOutline: mdiCheckCircleOutline,
      mdiSmoking: mdiSmoking,
      mdiSmokingOff: mdiSmokingOff,
      mdiPencilOutline: mdiPencilOutline,
      mdiTrashCanOutline: mdiTrashCanOutline,
      mdiPhone: mdiPhone,
      mdiAccountCheckOutline: mdiAccountCheckOutline,
      mdiAccountClockOutline: mdiAccountClockOutline,
      mdiAccountSearchOutline: mdiAccountSearchOutline,
      mdiHelpCircle: mdiHelpCircle,
      mdiCalendar: mdiCalendar,
      mdiAccountCogOutline: mdiAccountCogOutline,
      mdiDownload: mdiDownload,
      mdiCog: mdiCog,
      mdiContentCopy: mdiContentCopy,
      mdiSafeSquare: mdiSafeSquare,
      mdiSafeSquareOutline: mdiSafeSquareOutline,
      mdiEmail: mdiEmail,
      mdiDoNotDisturb: mdiDoNotDisturb,
    },
    whitelabel: whitelabel(process.env.VUE_APP_BRAND),
  }),
  computed: {
    testatorId() {
      return this.$store.getters.testatorId;
    },
    userId() {
      return this.$store.getters.userId;
    },
    isLoggedIn() {
      return this.$store && this.$store.getters.isLoggedIn;
    },
    isLoggedInAsSomeoneElse() {
      return this.$store && this.$store.getters.isLoggedInAsSomeoneElse;
    },
  },
  watch: {
    isLoggedIn(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$router.push("/");
      }
    },
  },
});
